import React from 'react';
import { Modal } from '@/Components/Modal/Modal';
import styles from './SelectDocumentModal.scss';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { useLocalization } from '@/Hooks';
import { SelectDocumentTable } from './SelectDocumentTable';
import { useSelectDocumentOptions } from './hooks/useSelectDocumentOptions';
import { useSelectDocumentModal } from './hooks/useSelectDocumentModal';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';

type Props = {
  onClose: () => void;
};

export function SelectDocumentModal({ onClose }: Props) {
  const {
    modalWindows: {
      documentPrintModal: {
        SelectDocumentModal: { Title },
      },
    },
    buttons: { Cancel, Ok, Previous },
  } = useLocalization();

  const { selectedDocumentTemplate } = useSelectDocumentOptions();
  const { onPrintSelectedDocuments, backPreviousStep } = useSelectDocumentModal(onClose);

  return (
    <Modal
      onClose={onClose}
      className={styles.modal}
      tourKey={'documentPrintTour'}
      modalId={'selectDocumentModal'}
      description={{
        title: Title,
      }}
    >
      <SelectDocumentTable />

      <ButtonsWrapper>
        <Button text={Cancel} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} onClick={onClose} />

        {selectedDocumentTemplate && (
          <Button text={Previous} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} onClick={backPreviousStep} />
        )}

        <Button autoFocus={true} text={Ok} theme={BUTTON_THEMES.SUCCESS} onClick={onPrintSelectedDocuments} />
      </ButtonsWrapper>
    </Modal>
  );
}
